export default {"src":"/_next/static/media/play-color-icon.5dfce1a2.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};